export function applyTheme(
  host: HTMLElement,
  theme: string | null | undefined,
  titleBgGradient?: string | null,
): void {
  if (!theme) return;
  host.style.setProperty('--dcs-primary', theme);
  host.style.setProperty('--dcs-primary-dark', darken(theme, 0.1));
  // 数字人沉浸式 UI 的头部 / CTA / 标题渐变统一引用 --dcs-primary-gradient。
  // 优先用后端下发的 titleBgGradient(与 web 线同字段);无则从主色派生一条 135deg 渐变,
  // 保证多租户每客户主色都能得到设计稿那种渐变质感,而非写死蓝紫。
  const gradient =
    titleBgGradient && titleBgGradient.trim()
      ? titleBgGradient
      : `linear-gradient(135deg, ${theme}, ${darken(theme, 0.18)})`;
  host.style.setProperty('--dcs-primary-gradient', gradient);
}

/** Hex 颜色变暗 ratio (0~1)。非 hex 输入直接回退原值 — widget UI 不至于崩。 */
function darken(hex: string, ratio: number): string {
  const m = /^#([0-9a-fA-F]{6})$/.exec(hex);
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  const r = Math.max(0, Math.round(((n >> 16) & 0xff) * (1 - ratio)));
  const g = Math.max(0, Math.round(((n >> 8) & 0xff) * (1 - ratio)));
  const b = Math.max(0, Math.round((n & 0xff) * (1 - ratio)));
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('')}`;
}
